import { DeferredRender } from "@/components/DeferedRender/DeferedRender";
import { Group, Accordion as MantineAccordion, Text } from "@mantine/core";
import { useLocalStorage } from "@mantine/hooks";
import { PrimitiveAtom, atom, useAtomValue } from "jotai";
import { BiSolidError } from "react-icons/bi";
import { css } from "vite-plugin-inline-css-modules";

export type SidebarAccordionModule = {
  key: string;
  icon: React.ReactNode;
  control: string;
  panel: React.ReactNode;
  errorAtom?: PrimitiveAtom<boolean>;
};

export const Accordion = ({
  accordionId = "sidebarAccordion",
  modules,
}: {
  modules: SidebarAccordionModule[];
  accordionId?: string;
}) => {
  const key = accordionId + ":sidebarAccordionState";

  const [state, setState] = useLocalStorage<string[] | boolean | null>({
    key,
    defaultValue: localStorage.getItem(key)
      ? JSON.parse(localStorage.getItem(key)!)
      : true,
  });

  const value = Array.isArray(state)
    ? state
    : state === true
      ? modules.map((item) => item.key)
      : [];

  return (
    <MantineAccordion
      variant="separated"
      multiple
      value={value}
      onChange={(value) => setState(value.length === 0 ? null : value)}
      radius={"xs"}
    >
      {modules.map((item, i) => (
        <DeferredRender key={item.key} idleTimeout={i * 2}>
          <AccordionItem
            item={{
              ...item,
              control: item.control,
            }}
          />
        </DeferredRender>
      ))}
    </MantineAccordion>
  );
};

const stubAtom = atom(false);

export const AccordionItem = ({ item }: { item: SidebarAccordionModule }) => {
  const isInError = useAtomValue(item?.errorAtom || stubAtom);

  return (
    <MantineAccordion.Item
      className={classes.item}
      value={item.key}
      style={{
        borderLeft: "4px solid var(--mantine-color-infomatic-2)",
      }}
    >
      <MantineAccordion.Control
        //icon={item.icon}
        style={{
          background: !isInError
            ? "transparent"
            : `repeating-linear-gradient(
          45deg,
          transparent,
          transparent 10px,
          #97020211 10px,
          #97020211 20px
        )`,
        }}
      >
        <Group align="center">
          <Text size="sm" lh={1.6} fw={600}>
            {item.control}
          </Text>
          {isInError && <BiSolidError size={20} color="red" />}
        </Group>
      </MantineAccordion.Control>
      <MantineAccordion.Panel pt="sm">
        {!!item.panel && item.panel}
      </MantineAccordion.Panel>
    </MantineAccordion.Item>
  );
};

const classes = css`
  .item {
    background: white;
    &[data-active] {
      [data-accordion-control="true"] {
        border-bottom: 1px dashed var(--mantine-color-gray-3);
      }

      &[data-rotate] {
        transform: rotate(-90deg);
      }
    }
  }
`;
